import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    primary: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
    },
    secondary: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
    },
    background: {
      paper: '#121212',
      default: '#121212',
    },
    action: {
      selected: '#6143BC !important',
      hover: '#7153CC !important',
    },
    text: {
      primary: '#FBFBFB',
      secondary: '#FBFBFB',
    },
    error: {
      main: red.A400,
    },
    mode: 'dark',
  },
});

export default theme;
